import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DocumentActor } from 'src/app/models/actors';
import { ViewerDataService } from '../viewer-data.service';

@Component({
  selector: 'app-action-side-list',
  templateUrl: './action-side-list.component.html'
})
export class ActionSideListComponent {

  @Output('startNextAction') startNextAction = new EventEmitter();

  userActors: DocumentActor[] = [];
  currentActor!: DocumentActor;


  topSpacing: number = 85;
  bottomArrowSpacing: number = 25;
  actionBadgeHeight: number = 29;
  outOfViewIndexCounterTop = 0;
  outOfViewIndexCounterBottom = 0;


  actionsForTop: DocumentActor[] = [];
  actionsInScreen: DocumentActor[] = [];
  actionsForBottom: DocumentActor[] = [];

  constructor(private viewerDataService: ViewerDataService) {
    this.viewerDataService.getCurrentActors$().subscribe(currentActors => {
      this.userActors = currentActors;
    });
    this.viewerDataService.getCurrentActor$().subscribe(currentActor => {
      this.currentActor = currentActor;
    });
  }
  /**
   * Gets the element associated with the Action/Actor
   * Signing field for Sign, or the Button/Id element for Approve,act etc
   * @param action 
   * @returns 
   */
  private getElementForAction(action: DocumentActor): HTMLElement | null {
    let expectedFieldName = this.viewerDataService.createSigningFieldId(action.documentId, action.fieldName);
    let signingField = document.getElementById(expectedFieldName);
    let noSigningField = document.getElementById(action.action + "_" + action.id);
    return signingField ? signingField : noSigningField;
  }
  /**
   * Gets the Badge Element Associated with the given Action/Actor
   * @param action 
   * @returns 
   */
  private GetBadgeElementForAction(action: DocumentActor): HTMLElement | null {
    return document.getElementById('badge' + (action.badgeNumber));
  }

  /**
   * This runs ALOT, like every second/angular life cycle
   */
  ngAfterViewChecked(): void {
    // place Arrows
    this.positionArrows();
    // Reset Actions
    this.actionsForTop = [];
    this.actionsInScreen = [];
    this.actionsForBottom = [];
    // loop through your Actions/Actors
    if (this.userActors) {
      // first loop through and GET all positions (top,screen,bottom)
      this.userActors.forEach((action: DocumentActor) => {
        // grab element
        let associatedElement = this.getElementForAction(action);
        let badge = this.GetBadgeElementForAction(action);
        if (associatedElement && badge) {
          this.decidePositionsBadges(associatedElement, badge, action);
        }
      });

      // now that we know locations, adjust their positions
      // First we align all items that are out of the screen on the TOP
      // TOP
      if (this.actionsForTop.length > 0) {
        // RESET the alignment counter
        this.outOfViewIndexCounterTop = 0;
        this.actionsForTop.forEach(topAction => {
          // grab element (again)
          let badge = this.GetBadgeElementForAction(topAction);
          if (!badge) {
            return;
          }
          // increase the count, this aligns them best
          this.outOfViewIndexCounterTop++;
          // Align the Badge at the top, using the counter to align them
          this.positionBadgeAtTop(badge, this.outOfViewIndexCounterTop);
        });
      }

      // Then align all items that are visible on the SCREEN
      // SCREEN/MID
      if (this.actionsInScreen.length > 0) {
        this.actionsInScreen.forEach(onScreenActor => {
          // first look for a signing field (Sign)
          let associatedElement = this.getElementForAction(onScreenActor);
          let badge = this.GetBadgeElementForAction(onScreenActor);
          if (!associatedElement || !badge) {
            return;
          }
          this.positionBadgeAtElement(associatedElement, badge, onScreenActor.badgeNumber);
        });
      }

      // Last we align all items that are out of the screen on the BOTTOM
      // BOTTOM
      if (this.actionsForBottom.length > 0) {
        // RESET the alignment counter
        this.outOfViewIndexCounterBottom = 0;
        // We REVERSE the actions (since first drawn actions are at the bottom, and others are counted up. this prevents 4-3-2-1, but makes it 1-2-3-4) First rendered items are lowest        
        this.actionsForBottom = this.actionsForBottom.reverse();
        // now we loop
        this.actionsForBottom.forEach(bottomActor => {
          // grab element (again)
          let badge = this.GetBadgeElementForAction(bottomActor);
          if (!badge) {
            return;
          }
          // increase the count, this aligns them best
          this.outOfViewIndexCounterBottom++;
          // Align the Badge at the top, using the counter to align them
          this.positionBadgeAtBottom(badge, this.outOfViewIndexCounterBottom);
        });
      }
    }
  }

  public scrollToAction(): void {
    this.startNextAction.emit()
  }
  /**
   * This is a function that verifies where the Badge element should be drawn
   * And adds it to the appropiate Array (top, Screen,Bottom)
   * @param elementOfAction
   * @param badgeElement 
   * @param action 
   */
  private decidePositionsBadges(elementOfAction: HTMLElement, badgeElement: HTMLElement, action: DocumentActor) {
    // is element visible in screen:
    if (this.elementInViewport(elementOfAction)) {
      // element is IN screen, but we still do not want overlaps!
      if (elementOfAction)
        this.actionsInScreen.push(action);
    }
    // when not visible, decide if the badge should be at top, or bottom of screen
    else {
      // this checks IF you are ABOVE the page (and header), if SO display at bottom
      if (elementOfAction.getBoundingClientRect().y >= ((this.outOfViewIndexCounterTop * this.actionBadgeHeight) + 140)) {
        this.actionsForBottom.push(action);
      } else {
        this.actionsForTop.push(action);
      }
    }
  }
  /**
   * Draws the given Badge at the Bottom, using the counter to adjust its position
   * @param badgeElement 
   * @param badgePositionCounter 
   */
  private positionBadgeAtBottom(badgeElement: HTMLElement, badgePositionCounter: number) {
    badgeElement.style.top = '';
    badgeElement.style.bottom = ((badgePositionCounter * this.actionBadgeHeight) + this.bottomArrowSpacing) + 'px';
  }

  /**
   * Draws the given Badge at the TOP, using the counter to adjust its position
   * @param badgeElement 
   * @param badgePositionCounter 
   */
  private positionBadgeAtTop(badgeElement: HTMLElement, badgePositionCounter: number) {
    badgeElement.style.bottom = '';
    badgeElement.style.top = ((badgePositionCounter * this.actionBadgeHeight) + this.topSpacing) + 'px';
  }
  /**
   * Draws the given Badge at the given Element
   * @param badgeElement 
   * @param badgePositionCounter 
   */
  private positionBadgeAtElement(elementOfAction: HTMLElement, badgeElement: HTMLElement, badgeNumber: number) {
    badgeElement.style.bottom = '';
    badgeElement.style.top = Math.min(Math.max(elementOfAction.getBoundingClientRect().y, (badgeNumber * this.actionBadgeHeight) + this.topSpacing), window.innerHeight - ((badgeNumber * this.actionBadgeHeight))) + 'px';
    let arrowBottom = document.getElementById('square-perform-action-bottom');
    if (arrowBottom && this.elementInViewport(arrowBottom)) {
      // calculate possible locations
      let positionBasedOnScreen = Math.max(elementOfAction.getBoundingClientRect().y, (badgeNumber * this.actionBadgeHeight) + this.topSpacing);
      let positionBasedOnOtherBadges = window.innerHeight - ((badgeNumber * this.actionBadgeHeight));
      // get the "lowest" possible position BUT since this is based on Top, the distance is calculated DOWN, so the lowest is actually the highest positioned Badge
      badgeElement.style.top = (Math.min(positionBasedOnScreen, positionBasedOnOtherBadges)) + 'px';
    }

  }

  private positionArrows(): void {
    let arrowTop = document.getElementById('square-perform-action-top');
    let arrowBottom = document.getElementById('square-perform-action-bottom');
    let actionIndicator = document.getElementById('actionIndicator');

    if (arrowTop && actionIndicator) {
      arrowTop.style.top = -document.documentElement.scrollTop + this.topSpacing + 'px';
      if (this.elementInViewport(arrowTop))
        actionIndicator.style.marginTop = 'calc(' + arrowTop.style.top + ' + 75px)';
      else
        actionIndicator.style.marginTop = '0';
    }
    if (arrowBottom && actionIndicator) {
      arrowBottom.style.bottom = ((document.documentElement.scrollTop + window.innerHeight) - document.documentElement.scrollHeight) + 'px';
      if (arrowBottom.style.bottom < "20px") {
        arrowBottom.style.bottom = "20px";
      }
      actionIndicator.style.minHeight = 'calc(100vh - ' + arrowBottom.style.bottom + ' - ' + this.actionBadgeHeight + 'px)';
    }
  }

  private elementInViewport(pageElement: HTMLElement) {
    let bounding = pageElement.getBoundingClientRect();
    let hasBottomAndTopOutsideOfScreenBounderies = (
      // verifies top, by checking IF your bottom is outside of the top header
      // we do 0.1 for the header
      bounding.bottom < 0.1 * (window.innerHeight || document.documentElement.clientHeight) || 
      // verifies bottom, if your top is inside the screen
      // we SUBSTRACT a 0.1 header
      bounding.top > ((window.innerHeight || document.documentElement.clientHeight) - (0.1 * (window.innerHeight || document.documentElement.clientHeight)))  
    );
    // inverse it!
    return !hasBottomAndTopOutsideOfScreenBounderies;
  }

}
